var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('keep-alive',[_c('TheHeader')],1),_c('main',{attrs:{"id":"main"}},[_c('router-view')],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }